/**
 * Split tests to use in the app
 * Can be passed as a string (name) or an object with configuration
 * See defaults in split-test duck for default variants and other available options
 * @type {String|Array.Object}
 */

module.exports = [
  '598BundleDetailsSteamReviews',
  '604ThemedMysteryUpsell',
  '606PopupHitCardBundleCoverGrid',
  '607NewReceiptPageV4',
];
